module.exports = __webpack_public_path__ + "static/media/google-plus.3e44baa2.svg";